import TabbedSelector from '@/components/TabbedSelector'
import { anomaliesTabs } from '@/routes/hours/anomalies/AnomaliesPage.route'

export default function AnomaliesPage() {
  return (
    <>
      <h2 className={'content-block'}>Anomalie Fluida</h2>
      <div className={'dx-card responsive-paddings content-block'}>
        <TabbedSelector tabs={anomaliesTabs} />
      </div>
    </>
  )
}
